export enum ExecutionType {
  AUTOMATIC,
  MANUAL,
}

export namespace ExecutionType {
  let elements = [ExecutionType.AUTOMATIC, ExecutionType.MANUAL];
  let alias = "com.bcdfx.model.ExecutionType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
